import React from 'react'

type Variant = 'mandatory' | 'recommended' | 'optional' | 'published' | 'draft' | 'deprecated' |
               'available' | 'coming-soon' | 'planned' | 'success' | 'warning' | 'error' | 'info' | 'default'

interface BadgeProps {
  variant?: Variant
  children: React.ReactNode
  size?: 'sm' | 'md'
}

const variantStyles: Record<Variant, string> = {
  mandatory:    'background:#1a2a4d;color:#4683fc;border-color:#1964fa',
  recommended:  'background:#262626;color:#c8c9cc;border-color:#4b4b4d',
  optional:     'background:#262626;color:#898b8f;border-color:#575759',
  published:    'background:#0c4428;color:#15ab5b;border-color:#15ab5b',
  draft:        'background:#4d2c07;color:#f98600;border-color:#e07a02',
  deprecated:   'background:#4d0808;color:#de1212;border-color:#c41010',
  available:    'background:#0c4428;color:#15ab5b;border-color:#15ab5b',
  'coming-soon':'background:#4d2c07;color:#f98600;border-color:#e07a02',
  planned:      'background:#262626;color:#a8aaad;border-color:#4b4b4d',
  success:      'background:#0c4428;color:#15ab5b;border-color:#15ab5b',
  warning:      'background:#4d2c07;color:#f98600;border-color:#e07a02',
  error:        'background:#4d0808;color:#de1212;border-color:#c41010',
  info:         'background:#1a2a4d;color:#4683fc;border-color:#1964fa',
  default:      'background:#262626;color:#c8c9cc;border-color:#4b4b4d',
}

export function Badge({ variant = 'default', children, size = 'sm' }: Readonly<BadgeProps>) {
  const pad = size === 'sm' ? '2px 8px' : '4px 12px'
  const fs = size === 'sm' ? '11px' : '12px'
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      padding: pad,
      fontSize: fs,
      fontWeight: 500,
      lineHeight: '16px',
      borderRadius: '4px',
      border: '1px solid',
      whiteSpace: 'nowrap',
      ...Object.fromEntries((variantStyles[variant] ?? variantStyles['default']).split(';').map(s => {
        const [k, v] = s.split(':')
        return [k.trim().replace(/-([a-z])/g, (_, c) => c.toUpperCase()), v?.trim()]
      })),
    }}>
      {children}
    </span>
  )
}
